import {
  useSurveyTemplatesByTenant,
  useCreateSurveyTemplate,
  useDeleteSurveyTemplate,
} from './useSurveyTemplates';
import { SurveyTemplateDTO, CreateSurveyTemplateDTO } from '../dtos';

// Create wrapper hooks for DataManagement interface that are tenant-aware
export const createSurveyTemplatesDataManagementHooks = (tenantId: string) => {
  // Query hook wrapper
  const useSurveyTemplatesQuery = () => {
    const query = useSurveyTemplatesByTenant(tenantId);

    return {
      data: query.data?.data?.templates || [],
      isLoading: query.isLoading,
      isFetching: query.isFetching,
      error: query.error,
    };
  };

  // Create mutation wrapper
  const useCreateSurveyTemplateWrapper = () => {
    const createMutation = useCreateSurveyTemplate(tenantId);

    return {
      mutateAsync: async (data: CreateSurveyTemplateDTO): Promise<SurveyTemplateDTO> => {
        const result = await createMutation.mutateAsync({
          tenantId,
          title: data.title,
          description: data.description,
          status: data.status || 'DRAFT',
        });

        // Return the data from the response
        if (result?.data) {
          return result.data;
        }

        throw new Error('Failed to create survey template');
      },
      isPending: createMutation.isPending,
    };
  };

  // Delete mutation wrapper
  const useDeleteSurveyTemplateWrapper = () => {
    const deleteMutation = useDeleteSurveyTemplate(tenantId);

    return {
      mutateAsync: async (id: string): Promise<void> => {
        await deleteMutation.mutateAsync(id);
      },
      isPending: deleteMutation.isPending,
    };
  };

  return {
    useSurveyTemplatesQuery,
    useCreateSurveyTemplateWrapper,
    useDeleteSurveyTemplateWrapper,
  };
};
